import { attr } from '@ember-data/model';
import { equal, or } from '@ember/object/computed';
import { computed } from '@ember/object';
import { fragment } from 'ember-data-model-fragments/attributes';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default EmberDataBaseFragment.extend({
  type: attr('string'),
  isCard: equal('type', 'card'),
  isBankAccount: equal('type', 'payout_adjustment'),
  token: or('bankAccount.token', 'card.token'),
  // Depending on the type, one of these fields will be populated
  card: fragment('subscription-card'),
  bankAccount: fragment('subscription-bank-account'),
  typeAsString: computed('bankAccount.currentPaymentMethod', 'card.currentPaymentMethod', 'isCard', function () {
    if (this.isCard) {
      return this.card?.currentPaymentMethod;
    } else {
      return this.bankAccount?.currentPaymentMethod;
    }
  }),
  typeAsStringShort: computed('bankAccount.currentPaymentMethodShort', 'card.currentPaymentMethodShort', 'isCard', function () {
    if (this.isCard) {
      return this.card?.currentPaymentMethodShort;
    } else {
      return this.bankAccount?.currentPaymentMethodShort;
    }
  })
}).reopenClass({
  _modelNameForMigration: 'subscription-payment-source'
});